import React from 'react'

import EmployeeForm from './EmployeeForm'
import { EMPLOYEES_LIST } from '../../urls'
import { usePostRequest } from '../../hooks/request'

export default function EmployeeCreate({ onSuccess, onCancel, buildId }) {
    const brandCreate = usePostRequest({ url: EMPLOYEES_LIST })

    async function onSubmit(data) {
        const { success } = await brandCreate.request({
            data: {
                ...data,
                building: buildId,
                dailyRate: data.dailyRate || undefined,
                monthlySalary: data.monthlySalary || undefined,
            },
        })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>

            <EmployeeForm loading={brandCreate.loading} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
